<template>
  <div class="p-8">
    <h2 class="mb-4 text-lg font-bold">SmartDatePicker 测试</h2>
    <SmartDatePicker
      :startDate.sync="startDate"
      :endDate.sync="endDate"
      :startPlaceholder="'开始日期'"
      :endPlaceholder="'结束日期'"
      :clearable="true"
    />
    <div class="mt-6">
      <div>startDate: {{ startDate }}</div>
      <div>endDate: {{ endDate }}</div>
    </div>
  </div>
</template>

<script>
import SmartDatePicker from '@/components/SmartControls/SmartDatePicker.vue';
export default {
  name: 'SmartDatePickerDemo',
  components: { SmartDatePicker },
  data() {
    return {
      startDate: null,
      endDate: null,
    };
  },
};
</script>

<style scoped>
.p-8 {
  padding: 2rem;
}
</style>
